import { Logo } from "./Logo";
import { useSite } from "@/context/SiteContext";
import { COMPANY_NAME, CONTACT_ADDRESS, CONTACT_EMAIL, CONTACT_PHONE } from "@/constants/site";

export const Footer = ({ categories = [] }) => {
  const { settings } = useSite();
  const email = settings?.contact_email || CONTACT_EMAIL;
  const phone = settings?.contact_phone || CONTACT_PHONE;
  const blurb = settings?.footer_blurb;
  const address = settings?.contact_address || CONTACT_ADDRESS;
  const company = settings?.company_name || COMPANY_NAME;

  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Logo size="md" />
          {blurb && (
            <p className="mt-4 text-sm text-neutral-600 max-w-sm leading-relaxed">
              {blurb}
            </p>
          )}
          <p className="mt-6 font-mono-ui text-[10px] uppercase tracking-[0.2em] text-neutral-500">
            © {new Date().getFullYear()} {company}
          </p>
        </div>

        <div className="lg:col-span-5">
          <p className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-3">
            Use cases
          </p>
          <div className="grid grid-cols-2 gap-2">
            {categories.map((c) => (
              <a
                key={c.id}
                href={`#${c.slug || c.id}`}
                className="text-sm text-neutral-600 hover:text-neutral-950 transition-colors"
              >
                {c.name}
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-3">
            Contact
          </p>
          <a
            href={`mailto:${email}`}
            className="block text-sm text-neutral-800 hover:text-neutral-950"
            data-testid="footer-email"
          >
            {email}
          </a>
          <a
            href={`tel:${phone.replace(/\s+/g, "")}`}
            className="block mt-1 text-sm text-neutral-800 hover:text-neutral-950"
            data-testid="footer-phone"
          >
            {phone}
          </a>
          <p className="mt-4 text-sm text-neutral-600 leading-relaxed whitespace-pre-line">
            {address}
          </p>
        </div>
      </div>
    </footer>
  );
};
